import { cn } from '@/lib/cn';

export function Spinner({ className, label = '加载中' }: { className?: string; label?: string }) {
  return (
    <div className={cn('flex flex-col items-center justify-center gap-4 py-16 text-slate-500', className)} role="status">
      <span
        className="inline-block h-9 w-9 animate-spin rounded-full border-2 border-teal-100 border-t-teal-600"
        aria-hidden
      />
      <span className="text-sm font-medium text-slate-600">{label}…</span>
    </div>
  );
}
